import '../../style/index.less';
import './index.less';
import '../../input/style';
